import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import '../Assets/Css/contact.css';
import productbanner from '../Assets/Images/contactus.avif';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import { FaMobileAlt } from "react-icons/fa";

import { toast, Toaster } from 'react-hot-toast';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { BASE_URL } from '../BaseURL';



export default function Contact() {
  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    mobile: '',
    // requirements:'',
    address: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
      if (response.status === 200) {
        toast.success("Enquiry sent successfully!");
      }
    } catch (error) {
      toast.error("Failed to send enquiry.");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const updatedRequirements = checked
      ? [...formData.requirements, value]
      : formData.requirements.filter(item => item !== value);

    setFormData({ ...formData, requirements: updatedRequirements });
  };

  return (
    <>

      <Toaster />



      <div className='py-3'>

        {/* Contact Info Section */}
        <Container className="mb-5">
          <Row className="text-center mb-4 p-3">
            <Col className='pt-4'>
              <h2 className="Mainhead">Get in Touch</h2>

            </Col>
          </Row>
          <Row className="g-4 p-3">
            <Col md={6} >
              <Card className="h-100 shadow-lg p-3" style={{ border: 'none' }}>
                <Card.Body>
                  <h5 className="text-center fw-bold mb-3">Location</h5>

                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '10px' }}>
                    <MdLocationOn size={23} color="#AA5541" style={{ marginTop: '3px' }} />
                    <p className="mb-1">
                      <strong>Address :-</strong>
                      Texas 75077, USA

                    </p>
                  </div>

                  <a
                    href="mailto:david@sensenaturalproducts.com"
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'flex',
                      alignItems: 'start',
                      gap: '6px',
                      marginBottom: '10px'
                    }}
                  >
                    <MdEmail size={20} color="#AA5541" />
                    <p className="mb-0"><strong>Email —</strong>david@sensenaturalproducts.com</p>
                  </a>
                  <div className='mt-3'>
                   


<iframe 
  title="Sense Technologies, Inc."
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3342.5484707808805!2d-97.0680257243241!3d33.09466177353255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c32e5d0516be7%3A0x382cd369f0ca07b2!2s810%20Green%20Valley%20Ln%20%23810%2C%20Highland%20Village%2C%20TX%2075077%2C%20USA!5e0!3m2!1sen!2sin!4v1751364923330!5m2!1sen!2sin"
 width="100%"
  height="350" 
 allowfullscreen="" 
 loading="lazy" 
 referrerpolicy="no-referrer-when-downgrade">

 </iframe>

                  </div>

                </Card.Body>



              </Card>
            </Col>


            {/* Contact Form */}
            <Col md={6} >
              <Card className="h-100 shadow-lg" style={{ border: 'none' }}>
                <Card.Body className='className="contact-form-card'>
                  <h5 className="text-center fw-bold mb-3 pt-3 ">Contact Form</h5>
                  <Form onSubmit={handleSubmit} className='p-3'>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className='fw-bold'>Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="userName"
                            value={formData.userName}
                            onChange={handleChange}
                            placeholder="Enter your name"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className='fw-bold'>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className='fw-bold'>Mobile</Form.Label>
                          <Form.Control
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            maxLength={10}
                            onChange={handleChange}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            }}
                            placeholder="Enter your mobile"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className='fw-bold'>Address</Form.Label>
                          <Form.Control
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Enter your address"
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label className='fw-bold'>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Your message..."
                        required
                      />
                    </Form.Group>

                    <div className="d-grid justify-content-center">
                      <Button type="submit" className="contactsubmitbtn" disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" /> Sending...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>


        </Container>
      </div>
    </>
  );
}
